export default "/images/vendor/flag-icons/flags/1x1/eu.svg?8224e4265da2d4361a098d80fb7f85fa";